import { graphql, useStaticQuery } from 'gatsby';
import { TeamDatabaseQuestion } from '@bondvet/types/website';

const clinicTeamQuestionsQuery = graphql`
    query ClinicTeamQuestions {
        allClinicTeamQuestion {
            nodes {
                _id
                orderId
                clientQuestion
                display
                type
            }
        }
    }
`;

type QueryResult = {
    allClinicTeamQuestion: {
        nodes: ReadonlyArray<
            Pick<
                TeamDatabaseQuestion,
                '_id' | 'orderId' | 'clientQuestion' | 'display' | 'type'
            >
        >;
    };
};

export default function useTeamDatabaseQuestions() {
    const { allClinicTeamQuestion } = useStaticQuery<QueryResult>(
        clinicTeamQuestionsQuery,
    );

    return allClinicTeamQuestion?.nodes ?? [];
}
